import { SxProps } from "@mui/material";
import { DataGrid, GridColDef, GridRowParams } from "@mui/x-data-grid";
import React from "react";

type DatagridTableComponentProps = {
  columns: GridColDef[];
  rows: any[];
  onRowClick?: (params: GridRowParams) => any;
  isDataLoading: boolean;
  sx?: SxProps;
};
const DatagridTable: React.FC<DatagridTableComponentProps> = ({
  rows,
  isDataLoading,
  columns,
  onRowClick,
  sx,
}) => {
  return (
    <DataGrid
      loading={isDataLoading}
      rows={rows}
      hideFooter
      onRowClick={onRowClick}
      sx={sx}
      hideFooterPagination
      columns={columns}
      disableRowSelectionOnClick
    />
  );
};

export default DatagridTable;
